import React from "react";
import Hero from "../Component/Hero";
import Incubations from "../Component/Incubations";
import About from "../Component/About";
import Footer from "../Component/Footer";
import TechShowcase from "../Component/TechShowcase";
import ProductShowcase from "../Component/ProductShowcase";

function HomePage({ islogin, setUserSidebar, setShowChatbot }) {
  return (
    <div className="bg-[#000000] text-white min-h-screen font-sans" style={{ fontFamily: "'Lato', sans-serif" }}>
      <Hero islogin={islogin} setUserSidebar={setUserSidebar} />
      <Incubations />
      <ProductShowcase />
      <TechShowcase />
      <About islogin={islogin} />
      <Footer />
    </div>
  );
}

export default HomePage;
